<div class="px-6 py-7">
  <!--TITULO E BOTÃO DE ADICIONAR NOVO CONFRONTO-->
  <div class="flex justify-between">
    <div>
      <p class="text-2xl font-bold text-sigecom-dark-gray">Tabela de Jogos</p>
    </div>
    <div>
      <!-- <sigecom-button
        class="text-center pt-2 pb-2 w-48 text-cbde-dark-blue font-medium fa-lg text-sm"
        icon="plus"
        sizeIcon="xl"
        title="NOVO CONFRONTO"
        (buttonClicked)="openModalNewConfrontation()"
      >
      </sigecom-button> -->
    </div>
  </div>

  <!--FILTROS INICIAL DAS TABELAS-->
  <sigecom-filter-games-table
    [isPrincipalFilter]="true"
    [isIndependentFilter]="false"
    customClass="mt-6 shadow-[3px_8px_8px_rgba(0,0,0,0.3)]"
    (initTableGamesSaved)="listenFilterSaved($event)"
    [petNrId]="this.petNrId"
  />

  <!--TOGGLE JOGOS / CLASSIFICAÇÃO-->
  <div
    class="mt-6 inline-flex rounded-full bg-white p-1 shadow-[3px_8px_8px_rgba(0,0,0,0.12)] border border-gray-100"
  >
    <button
      type="button"
      class="px-6 py-2 rounded-full text-sm font-bold transition-colors duration-200"
      [ngClass]="
        selectedView === 'jogos'
          ? 'bg-sigecom-info text-white shadow-sm'
          : 'bg-transparent text-sigecom-info'
      "
      (click)="selectView('jogos')"
    >
      Jogos
    </button>
    <button
      type="button"
      class="px-6 py-2 rounded-full text-sm font-bold transition-colors duration-200"
      [ngClass]="
        selectedView === 'classificacao'
          ? 'bg-sigecom-info text-white shadow-sm'
          : 'bg-transparent text-sigecom-info'
      "
      (click)="selectView('classificacao')"
    >
      Classificação
    </button>
  </div>

  <!--INFORMAÇÕES DOS LOCAIS DE COMPETIÇÃO E SEUS CONFRONTOS-->

  <ng-container *ngIf="selectedView === 'jogos'">
    <div *ngFor="let gameTable of gamesTable">
      <sigecom-competition-local-games-table
        [gameTable]="gameTable"
        (gameTableEdit)="editGamesTableParticipants($event)"
        (editParticipantsEmit)="editConfrontationParticipants($event)"
        (refresh)="refreshGameTable()"
      />
    </div>
  </ng-container>

  <!--CLASSIFICAÇÃO-->
  <ng-container *ngIf="selectedView === 'classificacao'">
    <div class="mt-6 animate-slide-up">
      <ng-container *ngIf="classificationGroups.length">
        <div
          *ngFor="
            let group of classificationGroups;
            trackBy: trackClassificationGroupByPetNrId
          "
          class="bg-white shadow-lg min-h-[100%] flex-grow flex flex-col px-6 pt-4 pb-4 rounded-lg mb-4"
          [ngClass]="{ 'gap-4 pb-6': !group.minimized }"
        >
          <div
            class="w-full text-lg flex justify-between items-center font-bold text-sigecom-info"
          >
            <div class="flex flex-col gap-1 min-w-0">
              <span class="break-words">
                Classificação - {{ group.petTxNome }}
              </span>
              <span class="text-sm font-medium text-sigecom-gray break-words">
                {{ group.eveTxNome }} - {{ group.catTxSexo }}
              </span>
            </div>
            <fa-icon
              (click)="toggleClassificationGroup(group)"
              icon="chevron-down"
              class="cursor-pointer transition-all duration-300"
              [ngClass]="{ 'rotate-180': group.minimized }"
            />
          </div>

          <div
            class="overflow-hidden"
            [ngClass]="{ 'h-0': group.minimized }"
          >
            <div
              *ngIf="group.loading"
              class="bg-white rounded-lg border border-gray-200 shadow-sm p-6 text-center text-sigecom-gray"
            >
              Carregando classificações...
            </div>

            <div class="flex flex-col gap-4">
              <div
                *ngIf="group.loaded && !group.chaves.length"
                class="bg-white rounded-lg p-4 text-center text-sigecom-gray"
              >
                Nenhuma classificação encontrada para esta parametrização
              </div>

              <ng-container *ngFor="let chave of group.chaves">
                <div class="bg-gray-100 rounded-lg p-4">
                  <div
                    class="flex items-center justify-between gap-3 mb-3 text-sigecom-info"
                  >
                    <p class="text-lg font-bold">{{ chave.cheTxNome }}</p>
                    <p class="text-sm font-semibold text-sigecom-gray">
                      {{ chave.classificacoes.length }} participante(s)
                    </p>
                  </div>

                  <div
                    *ngIf="chave.classificacoes.length; else emptyKeyClassification"
                    class="bg-white rounded-lg overflow-x-auto"
                  >
                    <table class="w-full min-w-[64rem] text-sm">
                      <thead class="bg-sigecom-info text-white">
                        <tr>
                          <th class="px-3 py-2 text-center">Pos.</th>
                          <th class="px-3 py-2 text-left">Participante</th>
                          <th class="px-3 py-2 text-center">Pts</th>
                          <th class="px-3 py-2 text-center">Vit.</th>
                          <th class="px-3 py-2 text-center">Emp.</th>
                          <th class="px-3 py-2 text-center">Der.</th>
                          <th class="px-3 py-2 text-center">Jogos</th>
                          <th class="px-3 py-2 text-center">PG</th>
                          <th class="px-3 py-2 text-center">PP</th>
                          <th class="px-3 py-2 text-center">PM</th>
                          <th class="px-3 py-2 text-center">PS</th>
                          <th class="px-3 py-2 text-left">Desempate</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let classificacao of chave.classificacoes"
                          class="border-b border-gray-100 last:border-b-0"
                        >
                          <td
                            class="px-3 py-2 text-center font-semibold text-sigecom-info"
                          >
                            {{ classificacao.claNrPosicao }}º
                          </td>
                          <td class="px-3 py-2 font-semibold text-sigecom-info">
                            {{ classificacao.incTxResumo }}
                          </td>
                          <td class="px-3 py-2 text-center">
                            {{ classificacao.claNrPontos }}
                          </td>
                          <td class="px-3 py-2 text-center">
                            {{ classificacao.claNrVitorias }}
                          </td>
                          <td class="px-3 py-2 text-center">
                            {{ classificacao.claNrEmpates }}
                          </td>
                          <td class="px-3 py-2 text-center">
                            {{ classificacao.claNrDerrotas }}
                          </td>
                          <td class="px-3 py-2 text-center">
                            {{ classificacao.claNrQtdJogos }}
                          </td>
                          <td class="px-3 py-2 text-center">
                            {{ classificacao.claNrPeriodosGanhos }}
                          </td>
                          <td class="px-3 py-2 text-center">
                            {{ classificacao.claNrPeriodosPerdidos }}
                          </td>
                          <td class="px-3 py-2 text-center">
                            {{ classificacao.claNrPontosMarcados }}
                          </td>
                          <td class="px-3 py-2 text-center">
                            {{ classificacao.claNrPontosSofridos }}
                          </td>
                          <td class="px-3 py-2">
                            {{ classificacao.claTxCriterioDesempate || "-" }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <ng-template #emptyKeyClassification>
                    <div class="bg-white rounded-lg p-4 text-center text-sigecom-gray">
                      Nenhuma classificação encontrada para esta chave
                    </div>
                  </ng-template>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
      <div
        *ngIf="!classificationGroups.length"
        class="bg-white rounded-lg border border-gray-200 shadow-sm p-6 text-center text-sigecom-gray"
      >
        Selecione uma fase para visualizar as classificações
      </div>
    </div>
  </ng-container>
  <div>
    <!--MODAL DE NOVO CONFRONTO-->
    <sigecom-modal
      [open]="modalNewConfrontation"
      (modalStateChange)="closeModalNewConfrontation()"
    >
      <div>
        <p class="text-2xl text-sigecom-dark-gray">
          {{ isEditing ? "Editar Confronto" : "Novo Confronto" }}
        </p>

        <!--Os filtro ja se comunicam entre si para manter a consistencia do valor de ambos ATRAVÉS DO SERVICE !!!!-->
        <!--Filtro que aparece em novo confronto-->
        <sigecom-filter-games-table
          *ngIf="!isEditing"
          [isIndependentFilter]="false"
          customClass="px-0"
        />
        <!-- filtro que aparece na edição: OBS:ele não modifica o serviço de filtro para não perder os estado anterior
          salvo nele-->
        <sigecom-filter-games-table
          *ngIf="isEditing"
          [isIndependentFilter]="true"
          [isEditingFight]="isEditing"
          [clashByHourEdit]="clashByHourEdit"
          [gamesTableEdit]="gameTableEdit"
        />

        <div class="grid grid-cols-2 gap-4 text-center pb-2 font-medium">
          <p class="text-sigecom-gray">Equipe A</p>
          <p class="text-sigecom-gray">Equipe B</p>
        </div>
        <div
          class="w-full flex justify-around items-center transition-opacity duration-500"
          [ngClass]="{ 'opacity-50': !isAllSelected }"
          [style.pointerEvents]="isAllSelected ? 'auto' : 'none'"
        >
          <div
            class="w-full bg-[#E5E7EB] h-12 rounded-lg flex justify-between items-center cursor-pointer"
            (click)="openModalAddParticipants('A')"
          >
            <p class="pl-4 text-sm font-bold">
              {{
                selectedParticipantA?.inscricaoEtapaDto?.ineObjInscricao
                  ?.incTxResumo
              }}
            </p>
            <fa-icon
              class="text-sigecom-info pr-8"
              [icon]="['fas', 'pen']"
            ></fa-icon>
          </div>
          <p class="mr-3 ml-3 text-xl font-semibold text-[#787878]">X</p>
          <div
            class="w-full bg-[#E5E7EB] h-12 rounded-lg flex justify-between items-center cursor-pointer"
            (click)="openModalAddParticipants('B')"
          >
            <p class="pl-4 text-sm font-bold">
              {{
                selectedParticipantB?.inscricaoEtapaDto?.ineObjInscricao
                  ?.incTxResumo
              }}
            </p>
            <fa-icon
              class="text-sigecom-info pr-8"
              [icon]="['fas', 'pen']"
            ></fa-icon>
          </div>
        </div>
        <div class="text-sm pt-6 font-medium w-full flex justify-end">
          <sigecom-button
            title="Salvar"
            type="info"
            class="pt-2 pb-2 w-28 rounded-lg transition-opacity duration-500"
            icon="save"
            sizeIcon="2x"
            [enableLoading]="enableLoading"
            [disabled]="
              enableLoading ||
              !isAllSelected ||
              (!selectedParticipantA && !selectedParticipantB)
            "
            [outlined]="true"
            (buttonClicked)="saveConfrontation()"
          />
        </div>
      </div>
    </sigecom-modal>

    <!--Modal de adicionar Participante-->
    <sigecom-modal
      class="w-[10rem]"
      [open]="modalAddParticipants"
      [showCloseButton]="true"
      (modalStateChange)="closeModalAddParticipants()"
    >
      <p class="text-lg font-semibold text-[#787878]">
        Adicionar participante - Definir confronto
      </p>
      <sigecom-modal-add-participants
        [selectedParticipants]="participantsForModal"
        [embNrId]="embNrId"
        [cheNrId]="getCurrentFilter().chave!"
        [petNrId]="getCurrentFilter().fase!"
        *ngIf="modalAddParticipants"
        (viewParticipants)="openModalViewParticipants($event)"
        (selectedParticipant)="participantAdded($event)"
      />
    </sigecom-modal>
  </div>
</div>
